import axios from "axios";
//import qs from "querystring";

export const AuthService = {
    async login(user) {
        try {
            user.action = "login";
            const url = "autoleie/login";
            const response = await axios.post(url, new URLSearchParams(user).toString(), { "content-type": "application/x-www-form-urlencoded", withCredentials: true });
            if (response.status != 200) {
                throw new Error(response);
            }
            // FIXME: Check actual result, e.g. if the json contains correct data.
            if (response.headers['content-type'] && !response.headers['content-type'].includes("html")) {
                throw new Error("Wrong content type on login: "+response.headers['content-type']);
            }
            if (response.data && response.data.length > 0) {
                throw new Error("Login response not empty");
            }

            return response.data;
        } catch ( err )
        {
            console.log( err );
            console.error(err.message);
            throw err;
        }
    },
    async logout() {
        sessionStorage.removeItem("userProfile");
        delete axios.defaults.headers.common["Authorization"];
    },
    async register(user) {
        const response = await axios.post({ url: "register", data: user, headers: { "content-type": "application/json" } });
        if (response.status != 200) throw new Error(response.message);
        return response.data;
    },
    async getUserProfile(username) {

        if (!username) {
            const profile = this.getStoredUserProfile();
            if (profile) {
                username = profile.username || null;
            }
        }

        if (!username) {
            console.log("User not authenticated.");
        } else {
            const url = "booking/customers/" + encodeURIComponent(username);
            const response = await axios.get(url);
            if ( response.status != 200 ) throw new Error( response );
           
            return response.data;
        }
    },
    generatePassword(length) {
        const charset = "!?$#abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    },
    isLoggedIn() {
        console.log("isLoggedIn...");
        const profile = JSON.parse(sessionStorage.getItem("userProfile")) || null;
        console.log("User profile is: " + (profile != null ? "Ok" : "Not ok!"));
        return profile != null;
    },
    getStoredUserProfile() {
        return JSON.parse(sessionStorage.getItem("userProfile")) || null;
    },
};
